import TypeIt from 'typeit';
import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);


export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    if ($('#Ticker').length) {
      if (window.cryptk.typeit_settings.length > 0) {
        const typeContents = window.cryptk.typeit_settings;
        const typeItInstance = new TypeIt('#Ticker', {
          speed: 90,
          breakLines: false,
          loop: true,
          autoStart: false,
        });

        typeContents.forEach(item => {
          const text = item.text || '';
          typeItInstance.type(text, {delay: item.delay || 1000}).delete(item.delete || text.length).pause(item.pause || 400)
        });
        typeItInstance.go();
      }
    }

    //case tab logic
    $('.cases__action__item').on('click', function () {
      let currentDataAttr = $(this).data('name')

      $('.cases__action__item').removeClass('active')
      $(this).addClass('active')

      $('.cases__content__item').removeClass('active')
      $(`.cases__content__item[data-name='${currentDataAttr}']`).addClass('active')
    });

    //case tab
    $('.head-button').on('click', function () {
      let currentDataAttr = $(this).data('mobile')

      $('.cases__content__item').removeClass('active')
      $(`.cases__content__item[data-name='${currentDataAttr}']`).addClass('active')
    });
    //faq active item
    $('.faq__head__button').on('click', function () {
      $(this).toggleClass('active')
      // $('.faq__item').removeClass('active')
      $(this).parent().parent().toggleClass('active')
    });

    //faq more/less logic
    $('.more').on('click', function () {
      $('.additional').addClass('display')
      $(this).removeClass('active')
      $('.less').addClass('active')
    });

    $('.less').on('click', function () {
      $('.additional').removeClass('display')
      $(this).removeClass('active')
      $('.more').addClass('active')
    });

    //why-us /less logic
    $('.whyMore').on('click', function () {
      $('.why__item').addClass('showMobile')
      $(this).removeClass('active')
      $('.whyLess').addClass('active')
    });

    $('.whyLess').on('click', function () {
      $('.why__item').removeClass('showMobile')
      $(this).removeClass('active')
      $('.whyMore').addClass('active')
    });

    //result more/less logic
    $('.resultMore').on('click', function () {
      $('.result__item').addClass('mobile')
      $(this).removeClass('active')
      $('.resultLess').addClass('active')
    });

    $('.resultLess').on('click', function () {
      $('.result__item').removeClass('mobile')
      $(this).removeClass('active')
      $('.resultMore').addClass('active')
    });


    //case tab logic
    $('.content__more').on('click', function () {
      let description = $(this).data('description')
      let name = $(this).data('name')
      let position = $(this).data('position')
      let avatar = $(this).data('avatar')
      let rating = $(this).data('rating')

      $('.popup').addClass('active')
      $('.popup__description').text(description)
      $('.popup__info__name').text(name)
      $('.popup__info__position').text(position)
      $('.popup__avatar').attr('src', avatar)

      $('.popup__info__star').removeClass('active')
      const starArr = Array.from($('.popup__info__star'))

      starArr.forEach((children, idx) => {
        if (idx <= rating) {
          starArr[idx].classList.add('active');
        }
      })
    });

    $('.popup__close').on('click', function () {
      $('.popup').removeClass('active')
    });

    //result more/less logic
    $('.testimonialsMore').on('click', function () {
      $('.content').addClass('mobile')
      $(this).removeClass('active')
      $('.testimonialsLess').addClass('active')
    });

    $('.testimonialsLess').on('click', function () {
      $('.content').removeClass('mobile')
      $(this).removeClass('active')
      $('.testimonialsMore').addClass('active')
    });
  },

};



// WEBPACK FOOTER //
// ./scripts/routes/home.js